import { Injectable, EventEmitter, Injector } from '@angular/core';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

@Injectable()
export class MapSettingsService extends DiagnosedItem {

    poiVisiblityChange: EventEmitter<any> = new EventEmitter<any>();

    hiddenCategoriesIds: number[] = [];

    constructor(protected injector: Injector) {
        super(injector);
    }

    changeVisiblity(categoryVisiblity: any) {

        if (categoryVisiblity && categoryVisiblity.category) {

            if (categoryVisiblity.hidden) {
                this.hiddenCategoriesIds.push(categoryVisiblity.category.Id);
            }
            else {

                var index = this.hiddenCategoriesIds.findIndex(x => x == categoryVisiblity.category.Id);

                if (index >= 0) {
                    this.hiddenCategoriesIds.splice(index);
                }
            }

            this.poiVisiblityChange.emit(categoryVisiblity);
        }
    }

    allowToShow(categoryId) {

        return this.hiddenCategoriesIds.findIndex(x => x == categoryId) == -1;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map-settings.service.ts